import React from 'react';
import InterviewHistory from '../../../components/pass/interview/history';
import NoAffiliateAuthWrap from '@components/common/modals/affiliateModal/noAffiliateAuthWrap';

const NoAffiliateAuthWrapTitle = (
  <>
    기출 면접 연습 서비스는
    <br />
    인증된 회원만 이용 가능해요.
  </>
);

const PassInterviewHistoryPage = () => {
  return (
    <NoAffiliateAuthWrap title={NoAffiliateAuthWrapTitle}>
      <InterviewHistory />
    </NoAffiliateAuthWrap>
  );
};
export default PassInterviewHistoryPage;
